import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewclientComponent } from './newclient.component';
import { AuthGuard }      from '../shared/auth.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'newclient', component: NewclientComponent, canActivate: [AuthGuard] }
    ])
  ],
  exports: [RouterModule]
})
export class NewclientRoutingModule { }
